import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App.js";
import { TopProgressBar } from "./components/TopProgressBar.js";
import { loadRuntimeConfig } from "./lib/api.js";
import "./styles.css";

/**
 * Boot order matters: the runtime config is fetched BEFORE React renders.
 *
 * Rendering first and fetching after would mean the first requests fire against an
 * undefined API URL, and the failure would look like an auth problem rather than a
 * config one. If `/config.json` cannot be read the app refuses to start and says so —
 * a dashboard that renders and cannot reach its API is worse than one that admits it.
 */
const root = document.getElementById("root");
if (root === null) throw new Error("#root is missing from index.html");

loadRuntimeConfig()
  .then((config) => {
    createRoot(root).render(
      <StrictMode>
        {/*
          Rendered as a SIBLING of the app, not inside it. The bar is `position: fixed`, so
          its place in the tree is irrelevant to where it paints — and keeping it out of
          App means it survives every one of App's branch returns (login, set-password,
          dashboard) rather than being remounted, and covers pre-auth fetches too.
        */}
        <TopProgressBar />
        <App config={config} />
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    root.innerHTML =
      '<div class="boot-error"><h1>Ecomally could not start</h1>' +
      "<p>The dashboard could not read its configuration. This is a deployment problem, not something you can fix by retrying.</p></div>";
    // No logger exists in a browser bundle, and a console line lands in a merchant's
    // devtools — the same reasoning .ai/02 makes for packages/tracker. The message on
    // screen is the report.
    void error;
  });
